export default "./dist/stdassets/images/icons/file-save.png";